import React from "react"
import styled from "styled-components"
import { PADDING } from "@/constants"
import { getCssSizeValue } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"

const StyledMargin = styled.div`
	&.${PADDING.EXTRA_SMALL} {
		height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.MOBILE].xs, BREAKPOINTS.MOBILE)};
	}

	&.${PADDING.SMALL} {
		height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.MOBILE].s, BREAKPOINTS.MOBILE)};
	}

	&.${PADDING.MEDIUM} {
		height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.MOBILE].m, BREAKPOINTS.MOBILE)};
	}

	&.${PADDING.LARGE} {
		height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.MOBILE].l, BREAKPOINTS.MOBILE)};
	}

	&.${PADDING.EXTRA_LARGE} {
		height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.MOBILE].xl, BREAKPOINTS.MOBILE)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		&.${PADDING.EXTRA_SMALL} {
			height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.TABLET].xs, BREAKPOINTS.TABLET)};
		}

		&.${PADDING.SMALL} {
			height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.TABLET].s, BREAKPOINTS.TABLET)};
		}

		&.${PADDING.MEDIUM} {
			height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.TABLET].m, BREAKPOINTS.TABLET)};
		}

		&.${PADDING.LARGE} {
			height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.TABLET].l, BREAKPOINTS.TABLET)};
		}

		&.${PADDING.EXTRA_LARGE} {
			height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.TABLET].xl, BREAKPOINTS.TABLET)};
		}
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		&.${PADDING.EXTRA_SMALL} {
			height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.DESKTOP].xs, BREAKPOINTS.DESKTOP)};
		}

		&.${PADDING.SMALL} {
			height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.DESKTOP].s, BREAKPOINTS.DESKTOP)};
		}

		&.${PADDING.MEDIUM} {
			height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.DESKTOP].m, BREAKPOINTS.DESKTOP)};
		}

		&.${PADDING.LARGE} {
			height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.DESKTOP].l, BREAKPOINTS.DESKTOP)};
		}

		&.${PADDING.EXTRA_LARGE} {
			height: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.DESKTOP].xl, BREAKPOINTS.DESKTOP)};
		}
	}
`

const Margin = ({ variant }) => {
	return <StyledMargin className={variant} />
}

export default Margin
